import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function New(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9999 18.8499C14.8876 18.8499 18.8499 14.8876 18.8499 9.9999C18.8499 5.11218 14.8876 1.1499 9.9999 1.1499C5.11218 1.1499 1.1499 5.11218 1.1499 9.9999C1.1499 14.8876 5.11218 18.8499 9.9999 18.8499Z"
        stroke={color || "#bbb"}
        stroke-width="2.3"
      />
      <path
        d="M14.286 10.4269H10.714V13.9979C10.714 14.1874 10.6387 14.3691 10.5047 14.5031C10.3707 14.6371 10.189 14.7124 9.99951 14.7124C9.81001 14.7124 9.62828 14.6371 9.49428 14.5031C9.36029 14.3691 9.28501 14.1874 9.28501 13.9979V10.4269H5.71401C5.52451 10.4269 5.34278 10.3516 5.20878 10.2176C5.07479 10.0836 4.99951 9.9019 4.99951 9.7124C4.99951 9.52291 5.07479 9.34117 5.20878 9.20718C5.34278 9.07318 5.52451 8.9979 5.71401 8.9979H9.28601V5.4269C9.28601 5.23741 9.36129 5.05567 9.49528 4.92167C9.62928 4.78768 9.81101 4.7124 10.0005 4.7124C10.19 4.7124 10.3717 4.78768 10.5057 4.92167C10.6397 5.05567 10.715 5.23741 10.715 5.4269V8.9989H14.286C14.4755 8.9989 14.6572 9.07418 14.7912 9.20818C14.9252 9.34217 15.0005 9.52391 15.0005 9.7134C15.0005 9.9029 14.9252 10.0846 14.7912 10.2186C14.6572 10.3526 14.4755 10.4279 14.286 10.4279V10.4269Z"
        fill={"#bbb"}
        stroke={"#bbb"}
        stroke-width="1"
      />
    </svg>
  );
}
